import { PlayStylesDict } from "../../../redux/players/playersSlice";
import axios from "../../apiFc24";

export const getPlayStyles = async () => {
  const res = await axios.get<PlayStylesDict>("/players/play-styles");
  return res.data;
};
